import moment from "moment";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { getParentNamesAPI } from "../../service/AuthService";
import Loader from "../../components/Loader";
import { getUniversalCasinoBetsAPI } from "../../service/casino";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

export default function CasinoWrapper() {
  const [bookOpen, setBookOpen] = useState(false);
  const [options, setOptions] = useState({
    liveBet: false,
    partnershipBook: false,
  });
  const location = useLocation();
  const userData = useSelector((state) => state.account.userData);
  const [userToFetch, setUserToFetch] = useState(false);
  const [clientBets, setClientBets] = useState([]);
  const [parentListOpen, setParentListOpen] = useState(false);
  const [parentList, setParentList] = useState([]);
  const [showMoreBets, setShowMoreBets] = useState(false);
  let casinoId = location.pathname.split("/");
  casinoId = casinoId[casinoId.length - 1];
  const [search, setSearch] = useState("");
  const handleDelete = () => {
    toast.success("Not available");
  };
  const getParentName = async () => {
    const { response } = await getParentNamesAPI(parentListOpen);
    if (response) {
      setParentList(response);
    }
  };
  const getClientBets = async (betStatus_) => {
    const { response } = await getUniversalCasinoBetsAPI(casinoId);

    if (response) {
      if (search.length > 0) {
        setClientBets(
          response.filter((item) =>
            item?.userName.toLowerCase().includes(search.toLowerCase())
          )
        );
      } else {
        setClientBets(response);
      }
    }
  };
  const [loading, setLoading] = React.useState(false);
  useEffect(() => {
    getParentName();
    let interval = setInterval(() => {
      getClientBets();
    }, 5000);
    return () => clearInterval(interval);
  }, [parentListOpen]);

  return (
    <div _ngcontent-ng-c3796931036="" className="main">
      {loading && <Loader />}
      <div _ngcontent-ng-c3796931036="" className="container-fluid">
        {parentListOpen && (
          <div
            _ngcontent-ng-c2822817509=""
            id="modalparentList"
            tabIndex={-1}
            aria-labelledby="yourModalLabel"
            className="modal fade show"
            aria-modal="true"
            role="dialog"
            style={{ display: "block", zIndex: "10000" }}
          >
            <div _ngcontent-ng-c2822817509="" className="modal-dialog modal-sm">
              <div _ngcontent-ng-c2822817509="" className="modal-content">
                <div
                  _ngcontent-ng-c2822817509=""
                  className="modal-header bg-primary"
                >
                  <h4
                    _ngcontent-ng-c2822817509=""
                    id="modal-basic-title"
                    className="modal-title"
                  >
                    Parent List
                  </h4>
                  <button
                    _ngcontent-ng-c2822817509=""
                    type="button"
                    aria-label="Close"
                    data-bs-dismiss="modal"
                    className="close"
                    onClick={() => setParentListOpen(false)}
                  >
                    <span _ngcontent-ng-c2822817509="" aria-hidden="true">
                      ×
                    </span>
                  </button>
                </div>
                <div
                  _ngcontent-ng-c2822817509=""
                  className="modal-body text-center"
                >
                  <ul _ngcontent-ng-c2822817509="" className="list-group">
                    {parentList &&
                      Object.values(parentList)?.length > 0 &&
                      Object.keys(parentList)
                        ?.sort((a, b) => b - a)
                        ?.map((item, index) => (
                          <li
                            _ngcontent-ng-c2822817509=""
                            className="list-group-item ng-star-inserted"
                          >
                            <b _ngcontent-ng-c2822817509="">
                              {" "}
                              {parentList[item]}{" "}
                            </b>
                          </li>
                        ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
        <router-outlet _ngcontent-ng-c3796931036="" />
        <app-gamedetails _nghost-ng-c3599551908="" className="ng-star-inserted">
          <div _ngcontent-ng-c3599551908="" className="animated fadeIn">
            <div _ngcontent-ng-c3599551908="" className="row">
              <div className="casino-wrapper-default ">
                <Outlet />
              </div>
              <div
                _ngcontent-ng-c3599551908=""
                className="col-lg-5 col-sm-12 analysis-sec col-12 right-section p-0"
              >
                <div _ngcontent-ng-c3599551908="" className="card open-bet">
                  <div
                    _ngcontent-ng-c3599551908=""
                    className="card-header card-accrdn card-matchodds"
                  >
                    <strong _ngcontent-ng-c3599551908=""> Book </strong>
                  </div>
                  <div
                    _ngcontent-ng-c3599551908=""
                    aria-expanded="true"
                    aria-hidden="false"
                    className="card-body open-bet-btns p-2 collapse in show"
                    style={{
                      overflow: "visible",
                      height: "auto",
                      display: "block",
                    }}
                  >
                    <div _ngcontent-ng-c3599551908="" className="row">
                      <div
                        _ngcontent-ng-c3599551908=""
                        className="col-6 col-sm-6 col-xl mb-3 mb-xl-0"
                      >
                        <button
                          _ngcontent-ng-c3599551908=""
                          role="button"
                          data-bs-toggle="modal"
                          data-bs-target="#masterBook"
                          onClick={() => {
                            setBookOpen("MASTER");
                            setUserToFetch(false);
                          }}
                          className="btn btn-primary"
                        >
                          {" "}
                          Master Book
                        </button>
                      </div>
                      <div
                        _ngcontent-ng-c3599551908=""
                        className="col-6 col-sm-6 col-xl mb-3 mb-xl-0"
                      >
                        <button
                          _ngcontent-ng-c3599551908=""
                          data-bs-toggle="modal"
                          onClick={() => {
                            setBookOpen("USER");
                            setUserToFetch(false);
                          }}
                          data-bs-target="#masterBook"
                          className="btn btn-primary"
                        >
                          {" "}
                          User Book
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div _ngcontent-ng-c3599551908="" className="card open-bet">
                  <div
                    _ngcontent-ng-c3599551908=""
                    className="card-header card-accrdn card-matchodds"
                  >
                    <div _ngcontent-ng-c3599551908="" className="mt-2">
                      <strong
                        _ngcontent-ng-c3599551908=""
                        style={{ float: "left" }}
                      >
                        {" "}
                        Live Bet{" "}
                      </strong>
                      <div
                        _ngcontent-ng-c3599551908=""
                        className="form-check form-check-inline ms-2"
                        style={{ float: "left" }}
                      >
                        <label
                          _ngcontent-ng-c3599551908=""
                          className="switch switch-label switch-primary switch-sm me-2"
                        >
                          <input
                            _ngcontent-ng-c3599551908=""
                            type="checkbox"
                            onChange={(e) =>
                              setOptions({
                                ...options,
                                liveBet: e.target.checked,
                              })
                            }
                            value={options.liveBet}
                            className="switch-input ng-untouched ng-pristine ng-valid"
                          />
                          <span
                            _ngcontent-ng-c3599551908=""
                            data-checked="✓"
                            data-unchecked="✕"
                            className="switch-slider"
                          />
                        </label>
                      </div>
                    </div>
                    <div _ngcontent-ng-c3599551908="" className="mt-2">
                      <strong
                        _ngcontent-ng-c3599551908=""
                        style={{ float: "left" }}
                      >
                        {" "}
                        Partnership Book{" "}
                      </strong>
                      <div
                        _ngcontent-ng-c3599551908=""
                        className="form-check form-check-inline ms-2"
                        style={{ float: "left" }}
                      >
                        <label
                          _ngcontent-ng-c3599551908=""
                          className="switch switch-label switch-primary switch-sm me-2"
                        >
                          <input
                            _ngcontent-ng-c3599551908=""
                            type="checkbox"
                            onChange={(e) =>
                              setOptions({
                                ...options,
                                partnershipBook: e.target.checked,
                              })
                            }
                            value={options.partnershipBook}
                            className="switch-input ng-untouched ng-pristine ng-valid"
                          />
                          <span
                            _ngcontent-ng-c3599551908=""
                            data-checked="✓"
                            data-unchecked="✕"
                            className="switch-slider"
                          />
                        </label>
                      </div>
                    </div>
                    <a
                      _ngcontent-ng-c3599551908=""
                      data-bs-toggle="modal"
                      data-bs-target="#modalCreditReference"
                      className="viewMore"
                      onClick={() => setShowMoreBets(true)}
                    >
                      {" "}
                      View More{" "}
                    </a>
                  </div>
                  <div
                    _ngcontent-ng-c3599551908=""
                    aria-expanded="true"
                    aria-hidden="false"
                    className="card-body open-bet-btns livebetbody collapse in show"
                    style={{
                      overflow: "visible",
                      height: "auto",
                      display: "block",
                    }}
                  >
                    {/**/}
                    {clientBets.length == 0 && (
                      <div
                        _ngcontent-ng-c3599551908=""
                        className="ng-star-inserted"
                      >
                        <p _ngcontent-ng-c3599551908="" className="text-center">
                          There are no any bet.
                        </p>
                      </div>
                    )}
                    <div
                      _ngcontent-ng-c3599551908=""
                      aria-expanded="true"
                      aria-hidden="false"
                      className="card-body open-bet-btns livebetbody collapse in show"
                      style={{
                        overflow: "visible",
                        height: "auto",
                        display: "block",
                      }}
                    >
                      <app-partnership-live-bets
                        _ngcontent-ng-c3599551908=""
                        _nghost-ng-c1486327317=""
                        className="ng-star-inserted"
                      >
                        <div
                          _ngcontent-ng-c1486327317=""
                          className="bet_slip ng-star-inserted"
                        >
                          <div
                            _ngcontent-ng-c1486327317=""
                            id="txnList"
                            name="txn"
                            className="slip-list"
                          >
                            <ul
                              _ngcontent-ng-c1486327317=""
                              id="backSlipHeader"
                              className="matched-head"
                            >
                              <li
                                _ngcontent-ng-c1486327317=""
                                className="col-bet"
                              >
                                Market Name
                              </li>
                              <li
                                _ngcontent-ng-c1486327317=""
                                className="col-odd"
                              >
                                Odds
                              </li>
                              <li
                                _ngcontent-ng-c1486327317=""
                                className="col-stake"
                              >
                                Stake
                              </li>
                              <li
                                _ngcontent-ng-c1486327317=""
                                className="col-profit"
                              >
                                Username
                              </li>
                            </ul>
                            {options.liveBet &&
                              clientBets?.map((item) => (
                                <dl
                                  _ngcontent-ng-c1486327317=""
                                  id="txn_304146967"
                                  className={`showInfo slip-back slip-${
                                    !item?.back ? "lay" : ""
                                  } ng-star-inserted`}
                                  style={{ display: "block" }}
                                >
                                  <dd
                                    _ngcontent-ng-c1486327317=""
                                    id="betInfo"
                                    className="refer refershow"
                                  >
                                    <span
                                      _ngcontent-ng-c1486327317=""
                                      id="placeDate"
                                    >
                                      Time:
                                      {moment(item?.placeDate + "Z")
                                        .utc()
                                        .local()
                                        .format("DD/MM/YY hh:mm:ss A")}
                                    </span>
                                  </dd>
                                  <dt _ngcontent-ng-c1486327317="">
                                    <span
                                      _ngcontent-ng-c1486327317=""
                                      className="slip-type ng-star-inserted"
                                    >
                                      {item?.back ? "BACK" : "LAY"}
                                    </span>
                                    <span
                                      _ngcontent-ng-c1486327317=""
                                      className="ellipsis-text"
                                    >
                                      {item?.runnerName}
                                    </span>
                                    <span
                                      _ngcontent-ng-c1486327317=""
                                      id="marketName"
                                      className="short-amount"
                                    >
                                      {item?.marketName}
                                    </span>
                                  </dt>
                                  <dd
                                    _ngcontent-ng-c1486327317=""
                                    id="price"
                                    className="col-odd"
                                  >
                                    {/**/}
                                    {item?.rate}{" "}
                                  </dd>
                                  <dd
                                    _ngcontent-ng-c1486327317=""
                                    id="size"
                                    className="col-stake"
                                  >
                                    {" "}
                                    {item?.amount}
                                  </dd>
                                  <dd
                                    _ngcontent-ng-c1486327317=""
                                    id="profitLiability"
                                    className="col-profit ellipsis-text"
                                  >
                                    <a
                                      onClick={() => {
                                        setParentListOpen(item?.userName);
                                      }}
                                      _ngcontent-ng-c1486327317=""
                                      style={{
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                      }}
                                    >
                                      {" "}
                                      {item?.userName}{" "}
                                    </a>
                                  </dd>
                                </dl>
                              ))}
                            {/**/}
                          </div>
                        </div>
                      </app-partnership-live-bets>
                      {/**/}
                      {/**/}
                    </div>

                    {/**/}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            _ngcontent-ng-c3599551908=""
            id="modalCreditReference"
            tabIndex={-1}
            aria-labelledby="yourModalLabel"
            aria-hidden="true"
            className="modal fade show"
            style={{
              display: showMoreBets ? "flex" : "none",
              overflow: "auto",
            }}
          >
            <div _ngcontent-ng-c3599551908="" className="modal-dialog modal-xl">
              <div _ngcontent-ng-c3599551908="" className="modal-content">
                <div
                  _ngcontent-ng-c3599551908=""
                  className="modal-header bg-primary"
                >
                  <h4
                    _ngcontent-ng-c3599551908=""
                    id="modal-basic-title"
                    className="modal-title"
                  >
                    View More Bet
                  </h4>
                  <button
                    _ngcontent-ng-c3599551908=""
                    type="button"
                    aria-label="Close"
                    data-bs-dismiss="modal"
                    className="btn close"
                    onClick={() => setShowMoreBets(false)}
                  >
                    <span _ngcontent-ng-c3599551908="" aria-hidden="true">
                      ×
                    </span>
                  </button>
                </div>
                <div _ngcontent-ng-c3599551908="" className="modal-body">
                  <app-view-more-bet
                    _ngcontent-ng-c3599551908=""
                    _nghost-ng-c3059760819=""
                    className="ng-star-inserted"
                  >
                    <div
                      _ngcontent-ng-c3059760819=""
                      className="table-responsive"
                    >
                      <div
                        id="DataTables_Table_0_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <div
                          id="DataTables_Table_0_filter"
                          className="dataTables_filter"
                        >
                          <label>
                            Search:
                            <input
                              type="search"
                              className=""
                              onChange={(e) => {
                                setSearch(e.target.value);
                                getClientBets();
                              }}
                              placeholder=""
                              aria-controls="DataTables_Table_0"
                            />
                          </label>
                        </div>
                        <table
                          _ngcontent-ng-c3059760819=""
                          datatable=""
                          role="table"
                          aria-busy="false"
                          aria-colcount={6}
                          className="table table-bordered table-striped dataTable no-footer"
                          id="DataTables_Table_0"
                          aria-describedby="DataTables_Table_0_info"
                        >
                          <thead _ngcontent-ng-c3059760819="" role="rowgroup">
                            <tr _ngcontent-ng-c3059760819="" role="row">
                              <th
                                _ngcontent-ng-c3059760819=""
                                className="sorting sorting_desc"
                                tabIndex={0}
                                aria-controls="DataTables_Table_0"
                                rowSpan={1}
                                colSpan={1}
                                aria-label="UserName: activate to sort column ascending"
                                aria-sort="descending"
                              >
                                UserName
                              </th>
                              <th
                                _ngcontent-ng-c3059760819=""
                                className="sorting"
                                tabIndex={0}
                                aria-controls="DataTables_Table_0"
                                rowSpan={1}
                                colSpan={1}
                                aria-label="Nation: activate to sort column ascending"
                              >
                                Nation
                              </th>
                              <th
                                _ngcontent-ng-c3059760819=""
                                className="sorting"
                                tabIndex={0}
                                aria-controls="DataTables_Table_0"
                                rowSpan={1}
                                colSpan={1}
                                aria-label="Amount: activate to sort column ascending"
                              >
                                Amount
                              </th>
                              <th
                                _ngcontent-ng-c3059760819=""
                                className="sorting"
                                tabIndex={0}
                                aria-controls="DataTables_Table_0"
                                rowSpan={1}
                                colSpan={1}
                                aria-label="User Rate: activate to sort column ascending"
                              >
                                User Rate
                              </th>
                              <th
                                _ngcontent-ng-c3059760819=""
                                className="sorting"
                                tabIndex={0}
                                aria-controls="DataTables_Table_0"
                                rowSpan={1}
                                colSpan={1}
                                aria-label="Place Date: activate to sort column ascending"
                              >
                                Place Date
                              </th>
                              <th
                                _ngcontent-ng-c3059760819=""
                                className="sorting"
                                tabIndex={0}
                                aria-controls="DataTables_Table_0"
                                rowSpan={1}
                                colSpan={1}
                                aria-label="Match Date: activate to sort column ascending"
                              >
                                Match Date
                              </th>
                              <th
                                _ngcontent-ng-c3059760819=""
                                className="sorting"
                                tabIndex={0}
                                aria-controls="DataTables_Table_0"
                                rowSpan={1}
                                colSpan={1}
                                aria-label="Game Type: activate to sort column ascending"
                              >
                                Game Type
                              </th>
                              <th
                                _ngcontent-ng-c3059760819=""
                                className="sorting"
                                tabIndex={0}
                                aria-controls="DataTables_Table_0"
                                rowSpan={1}
                                colSpan={1}
                                aria-label="Action: activate to sort column ascending"
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody _ngcontent-ng-c3059760819="">
                            {clientBets
                              ?.filter((item) =>
                                item?.userName
                                  .toLowerCase()
                                  .includes(search.toLowerCase())
                              )
                              ?.map((item) => (
                                <tr
                                  _ngcontent-ng-c3059760819=""
                                  className={`${
                                    item?.back ? "back" : "lay"
                                  } ng-star-inserted`}
                                >
                                  <td _ngcontent-ng-c3059760819="">
                                    <a
                                      onClick={() => {
                                        setParentListOpen(item?.userName);
                                      }}
                                      _ngcontent-ng-c3059760819=""
                                      className="plLink"
                                    >
                                      {item?.userName}
                                    </a>
                                  </td>
                                  <td _ngcontent-ng-c3059760819="">
                                    {item?.runnerName}{" "}
                                  </td>
                                  <td _ngcontent-ng-c3059760819="">
                                    {item?.amount}
                                  </td>
                                  <td _ngcontent-ng-c3059760819="">
                                    {" "}
                                    {item?.rate}
                                  </td>
                                  <td _ngcontent-ng-c3059760819="">
                                    {moment(item?.placeDate + "Z")
                                      .utc()
                                      .local()
                                      .format("DD/MM/YY hh:mm:ss A")}
                                  </td>
                                  <td _ngcontent-ng-c3059760819="">
                                    {" "}
                                    {moment(item?.placeDate + "Z")
                                      .utc()
                                      .local()
                                      .format("DD/MM/YY hh:mm:ss A")}
                                  </td>
                                  <td _ngcontent-ng-c3059760819="">
                                    {item?.marketName}
                                  </td>
                                  {userData?.userType == "TECH_ADMIN" && (
                                    <td _ngcontent-ng-c3059760819="">
                                      <button
                                        className="btn btn-danger"
                                        onClick={() => {
                                          handleDelete(item?.id);
                                        }}
                                      >
                                        Delete
                                      </button>
                                      <button
                                        className="btn btn-primary"
                                        onClick={() => {
                                          handleDelete(item?.id, true);
                                        }}
                                      >
                                        Un-Match
                                      </button>
                                    </td>
                                  )}
                                </tr>
                              ))}
                            {/**/}
                            {/**/}
                            <tr className="odd">
                              <td
                                valign="top"
                                colSpan={7}
                                className="dataTables_empty"
                              >
                                No matching records found
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          className="dataTables_info"
                          id="DataTables_Table_0_info"
                          role="status"
                          aria-live="polite"
                        >
                          Showing {clientBets.length} of {clientBets.length}{" "}
                          entries
                        </div>
                        <div
                          className="dataTables_paginate paging_full_numbers"
                          id="DataTables_Table_0_paginate"
                        >
                          <a
                            className="paginate_button first disabled"
                            aria-controls="DataTables_Table_0"
                            aria-disabled="true"
                            role="link"
                            data-dt-idx="first"
                            tabIndex={-1}
                            id="DataTables_Table_0_first"
                          >
                            First
                          </a>
                          <a
                            className="paginate_button previous disabled"
                            aria-controls="DataTables_Table_0"
                            aria-disabled="true"
                            role="link"
                            data-dt-idx="previous"
                            tabIndex={-1}
                            id="DataTables_Table_0_previous"
                          >
                            Previous
                          </a>
                          <span>
                            <a
                              className="paginate_button current"
                              aria-controls="DataTables_Table_0"
                              role="link"
                              aria-current="page"
                              data-dt-idx={0}
                              tabIndex={0}
                            >
                              1
                            </a>
                          </span>
                          <a
                            className="paginate_button next disabled"
                            aria-controls="DataTables_Table_0"
                            aria-disabled="true"
                            role="link"
                            data-dt-idx="next"
                            tabIndex={-1}
                            id="DataTables_Table_0_next"
                          >
                            Next
                          </a>
                          <a
                            className="paginate_button last disabled"
                            aria-controls="DataTables_Table_0"
                            aria-disabled="true"
                            role="link"
                            data-dt-idx="last"
                            tabIndex={-1}
                            id="DataTables_Table_0_last"
                          >
                            Last
                          </a>
                        </div>
                      </div>
                      {/**/}
                    </div>
                    <div
                      _ngcontent-ng-c3059760819=""
                      className="custom-modal-overlay d-none"
                    >
                      <div
                        _ngcontent-ng-c3059760819=""
                        className="custom-modal modal-xl"
                      >
                        <div
                          _ngcontent-ng-c3059760819=""
                          className="modal-header bg-primary"
                        >
                          <h4
                            _ngcontent-ng-c3059760819=""
                            id="modal-basic-title"
                            className="modal-title"
                          >
                            Parent List
                          </h4>
                          <button
                            _ngcontent-ng-c3059760819=""
                            type="button"
                            aria-label="Close"
                            data-bs-dismiss="modal"
                            className="btn close"
                          >
                            <span
                              _ngcontent-ng-c3059760819=""
                              aria-hidden="true"
                            >
                              ×
                            </span>
                          </button>
                        </div>
                        <div
                          _ngcontent-ng-c3059760819=""
                          className="custom-modal-body"
                        >
                          <table
                            _ngcontent-ng-c3059760819=""
                            className="table-striped table-bordered table"
                          >
                            <tbody _ngcontent-ng-c3059760819="">{/**/}</tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </app-view-more-bet>
                  {/**/}
                </div>
              </div>
            </div>
          </div>
        </app-gamedetails>
      </div>
    </div>
  );
}
